export default __webpack_public_path__ + "static/media/peperoncinoTtsIt_It60.0ed964fd.mp3";